// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import CaseManager from './components/CaseManager';
import EmailActionHandler from './components/auth/EmailActionHandler';
import PricingPage from './components/subscription/PricingPage';
import LandingPage from './components/landing/LandingPage';
import { AuthProvider } from './firebase/AuthContext';
import { initializeRemoteConfig } from './utils/RemoteConfig';

const isDev = process.env.NODE_ENV === 'development';
const GuideDevPanel = isDev ? require('./components/dev/GuideDevPanel').default : null;

/**
 * Main App Component with Routing
 */
function App() {
  // Inject custom scrollbar styles and initialize Remote Config
  useEffect(() => {
    // Scrollbar styles
    const style = document.createElement('style');
    style.id = 'custom-scrollbar-styles';
    style.textContent = `
      #root::-webkit-scrollbar {
        height: 8px;
      }
      
      #root::-webkit-scrollbar-track {
        background: #ffffff;
        margin-left: var(--sidebar-width, 224px);
      }
      
      #root::-webkit-scrollbar-thumb {
        background: #C0C7CE;
        border-radius: 4px;
      }
      
      #root::-webkit-scrollbar-thumb:hover {
        background: #8F99A3;
      }
    `;
    document.head.appendChild(style);

    // Initialize Remote Config
    initializeRemoteConfig().catch(error => {
      console.error('App - Failed to initialize Remote Config:', error);
    });

    return () => {
      document.getElementById('custom-scrollbar-styles')?.remove();
    };
  }, []);

  return (
    <ErrorBoundary>
      <AuthProvider>
        <ErrorBoundary>
          <Router>
            <Routes>
              {/* Landing page route for testing */}
              <Route path="/landing" element={<LandingPage />} />

              {/* Email action handler route */}
              <Route path="/auth/action" element={<EmailActionHandler />} />

              {/* Pricing page route */}
              <Route path="/pricing" element={<PricingPage />} />

              {/* Main app route */}
              <Route path="/*" element={<CaseManager />} />
            </Routes>
          </Router>

          {/* Dev-only guide testing panel — stripped out in production builds */}
          {isDev && <GuideDevPanel />}

        </ErrorBoundary>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;